module.exports = __webpack_public_path__ + "img/case-logo-4.fe0e6aac.png";